import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import DjProfile from "./components/DjProfile";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Testimonials />
    </>
  );
}

function ContactPage() {
  return (
    <div className="pt-24 md:pt-28" data-testid="contact-page">
      <Contact />
    </div>
  );
}

function App() {
  useEffect(() => {
    document.title =
      "Karnival Events & Entertainment | Ottawa DJ, AV & Event Décor";
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App bg-[#070707] text-[#FDFBF7]" data-testid="app-root">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/dj-avtaar" element={<DjProfile />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
